import { useState } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { api, errorText } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { AuthLayout } from "@/components/brand/AuthLayout";
import { Field, FormError } from "@/components/brand/Field";

export default function SignIn() {
  const { setUser } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const sessionEnded = typeof window !== "undefined" && new URLSearchParams(window.location.search).get("session") === "ended";
  const [form, setForm] = useState({ email: "", password: "" });
  const [error, setError] = useState(sessionEnded ? "Your session ended. Please sign in again." : "");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      const { data } = await api.post("/auth/login", form);
      setUser(data);
      nav(loc.state?.from || "/app", { replace: true });
    } catch (err) {
      setError(errorText(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <AuthLayout
      title="Sign in"
      subtitle="Welcome back."
      footer={<>New here? <Link className="ts-link" to="/signup" data-testid="go-signup-link">Create your account</Link></>}
    >
      <form onSubmit={submit} noValidate>
        <FormError message={error} testId="signin-error" />
        <Field id="email" label="Work email">
          <input id="email" data-testid="signin-email-input" className="ts-input" type="email" autoComplete="email" required value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
        </Field>
        <Field id="password" label="Password">
          <input id="password" data-testid="signin-password-input" className="ts-input" type="password" autoComplete="current-password" required value={form.password} onChange={(e) => setForm({ ...form, password: e.target.value })} />
        </Field>
        <button data-testid="signin-submit-button" className="ts-btn ts-btn-primary w-full mt-2" disabled={busy}>
          {busy ? "Checking…" : "Sign in"}
        </button>
        <div className="text-sm mt-4 text-center">
          <Link className="ts-link" to="/forgot" data-testid="forgot-password-link">Forgot your password?</Link>
        </div>
      </form>
    </AuthLayout>
  );
}
